import React, { createContext, useContext, useState, useEffect, useCallback, useRef } from "react";
import { api } from "@/lib/api";
import { setCompanyResolver } from "@/lib/pdf";

const DEFAULT_COMPANY = {
  company_name: "HNC Event Catering Co.",
  logo_data_url: null,
  address: "Kuala Lumpur, Malaysia",
  phone: "+60 12-345 6001",
  email: "hello@hnccatering.com",
  website: "www.hnccatering.com",
  payment_instructions: "HNC Event Catering Sdn Bhd · Maybank 5141 1234 5678",
  tax_rate: 6.0,
};

const CompanyContext = createContext({ company: DEFAULT_COMPANY, reload: () => {} });

export function CompanyProvider({ children }) {
  const [company, setCompany] = useState(DEFAULT_COMPANY);
  const ref = useRef(DEFAULT_COMPANY);

  const reload = useCallback(async () => {
    try {
      const r = await api.get("/company-settings");
      const merged = { ...DEFAULT_COMPANY, ...r.data };
      setCompany(merged);
      ref.current = merged;
    } catch {
      setCompany(DEFAULT_COMPANY);
      ref.current = DEFAULT_COMPANY;
    }
  }, []);

  useEffect(() => {
    setCompanyResolver(() => ref.current);
    reload();
  }, [reload]);

  return (
    <CompanyContext.Provider value={{ company, reload, setCompany }}>
      {children}
    </CompanyContext.Provider>
  );
}

export const useCompany = () => useContext(CompanyContext);
